import React from "react"
import { FaIcon } from "lib"

const SimpleIcon = ({ domRef, info, value, ...props }) => {
    if (!value) return null

    return <FaIcon icon={value} ref={domRef} {...props} />
}
export default React.memo(SimpleIcon)
